import type { ReactNode } from "react";

import { type SxProps, type Theme, ThemeProvider, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

import { createFernieFontTheme, FERNIE_FONT_VOICE } from "~/themes/fernieBrand";

interface FernieVoiceTextProps {
	children: ReactNode;
	component?: React.ElementType;
	sx?: SxProps<Theme>;
}

const FernieVoiceText = ({ children, component = "span", sx }: FernieVoiceTextProps) => {
	const outerTheme = useTheme();
	const voiceTheme = useMemo(() => createFernieFontTheme(outerTheme, FERNIE_FONT_VOICE), [outerTheme]);

	return (
		<ThemeProvider theme={voiceTheme}>
			<Typography component={component} sx={sx}>
				{children}
			</Typography>
		</ThemeProvider>
	);
};

export default FernieVoiceText;
